import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=48396d8f&scoped=true&"
import script from "./invoice.vue?vue&type=script&lang=ts&"
export * from "./invoice.vue?vue&type=script&lang=ts&"
import style0 from "./invoice.vue?vue&type=style&index=0&id=48396d8f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48396d8f",
  null
  
)

export default component.exports